export default __webpack_public_path__ + "static/media/GH_bathroom.94619e27.webp";